import React, { useEffect, useState, Fragment } from 'react'
import {Card, Col, Container, Form, InputGroup, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { formato_rut, validaNumeros, isValidParam } from '../../../common/Formatos'
import { obtenerDatosNoFormato } from '../../../store/actions/implicado-action'

const Implicado = ({ formik, setPaisImplicadoFinal, isImplicado, handleShowProp, setHandleShowProp, tipoInvolucradoTmp, tipoInvolucradoBD,
  stateChkConductor, setStateChkConductor, stateChkPropietario, setStateChkPropietario, setIdCiudadImplicado
}) => {

  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form_implicado, antecedentesCasos } = data_datos_generales
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { datosPantalla, comboPais, comboComunas, cfg_form37 } = data_datos_implicado

  const [datosSiniestro, setDatosSiniestro] = useState({})
  const [rutImplicado, setRutImplicado] = useState('')
  const [rutImplicadoNoFormato, setRutImplicadoNoFormato] = useState('')
  const [nombreImplicado, setNombreImplicado] = useState('')
  const [direccionImplicado, setDireccionImplicado] = useState('')
  const [emailImplicado, setEmailImplicado] = useState('')
  const [paisImplicado, setPaisImplicado] = useState('')
  const [paisMovilImplicado, setPaisMovilImplicado] = useState('')
  const [fonoImplicado, setFonoImplicado] = useState('')
  const [movilImplicado, setMovilImplicado] = useState('')
  const [comunaImplicado, setComunaImplicado] = useState('')
  const [ciudadImplicado, setCiudadImplicado] = useState('')

  const [muestraChk, setMuestraChk] = useState(false)
  
  const distpatch = useDispatch()
  useEffect(() => {

    distpatch(obtenerDatosNoFormato(rutImplicadoNoFormato))
  }, [rutImplicadoNoFormato])

  useEffect(() => {
    setPaisImplicadoFinal(paisImplicado)
  }, [paisImplicado])

  useEffect(() => {
    setRutImplicado('');
    setRutImplicadoNoFormato('');
    setNombreImplicado('');
    setDireccionImplicado('');
    setEmailImplicado('');
    setPaisImplicado('');
    setPaisMovilImplicado('');
    setFonoImplicado('');
    setMovilImplicado('');
    setComunaImplicado('');
    setCiudadImplicado('');

    setHandleShowProp(false);
  }, [handleShowProp])

  useEffect(() => {
    if (!isImplicado && datosPantalla?.datosPantalla[0]) {
      
      setStateChkConductor(
        datosPantalla && datosPantalla.datosPantalla[0]['esConductor'] && 
          isValidParam(datosPantalla.datosPantalla[0]['esConductor'] && datosPantalla.datosPantalla[0]['esConductor'] == 1) ? true : false
      )
      setStateChkPropietario(
        datosPantalla && datosPantalla.datosPantalla[0]['esPropietario'] && 
          isValidParam(datosPantalla.datosPantalla[0]['esPropietario'] && datosPantalla.datosPantalla[0]['esPropietario'] == 1) ? true : false
      )
      setRutImplicado(
        datosPantalla && datosPantalla.datosPantalla[0]['RutImplicado'] && 
        isValidParam(datosPantalla.datosPantalla[0]['RutImplicado']) ? formato_rut(datosPantalla.datosPantalla[0]['RutImplicado']) : ''
      )
      setRutImplicadoNoFormato(
        datosPantalla && datosPantalla.datosPantalla[0]['RutImplicado']
        //+ datosPantalla.datosPantalla['dvIdGirador']
      )
      setNombreImplicado(
        datosPantalla && datosPantalla.datosPantalla[0]['NombreImplicado'] && 
        isValidParam(datosPantalla.datosPantalla[0]['NombreImplicado']) ? datosPantalla.datosPantalla[0]['NombreImplicado'] : ''
      )
      setDireccionImplicado(
        datosPantalla && datosPantalla.datosPantalla[0]['DireccionImplicado'] && 
        isValidParam(datosPantalla.datosPantalla[0]['DireccionImplicado']) ? datosPantalla.datosPantalla[0]['DireccionImplicado'] : ''
      )
      setEmailImplicado(
        datosPantalla && datosPantalla.datosPantalla[0]['EmailImplicado'] && 
        isValidParam(datosPantalla.datosPantalla[0]['EmailImplicado']) ? datosPantalla.datosPantalla[0]['EmailImplicado'] : ''
      )

      setPaisImplicado(
        18001
        // datosPantalla &&
        // datosPantalla.datosPantalla[0]['18001'] !== undefined &&
        // datosPantalla.datosPantalla[0]['18001'] !== null &&
        // datosPantalla.datosPantalla[0]['18001'] !== ''
        // ? datosPantalla.datosPantalla[0]['18001']
        // : ''
      )
      setPaisMovilImplicado(
        18001
        // datosPantalla &&
        // datosPantalla.datosPantalla[0]['18001'] !== undefined &&
        // datosPantalla.datosPantalla[0]['18001'] !== null &&
        // datosPantalla.datosPantalla[0]['18001'] !== ''
        // ? datosPantalla.datosPantalla[0]['18001']
        // : ''
      )
      setFonoImplicado(
        datosPantalla && datosPantalla.datosPantalla[0]['FonoImplicado'] && 
        isValidParam(datosPantalla.datosPantalla[0]['FonoImplicado']) ? datosPantalla.datosPantalla[0]['FonoImplicado'] : ''
      )
      setMovilImplicado(
        datosPantalla && datosPantalla.datosPantalla[0]['MovilImplicado'] && 
        isValidParam(datosPantalla.datosPantalla[0]['MovilImplicado']) ? datosPantalla.datosPantalla[0]['MovilImplicado'] : ''
      )
      setComunaImplicado(
        datosPantalla && datosPantalla.datosPantalla[0]['IdComunaImplicado'] && 
        isValidParam(datosPantalla.datosPantalla[0]['IdComunaImplicado']) ? datosPantalla.datosPantalla[0]['IdComunaImplicado'] : ''
      )
      if(datosPantalla && datosPantalla.datosPantalla[0]['IdComunaImplicado'] && isValidParam(datosPantalla.datosPantalla[0]['IdComunaImplicado'])){
        const comunaActual = comboComunas &&
        comboComunas.comboComunas?.find((c) => c.id ===datosPantalla.datosPantalla[0]['IdComunaImplicado'])
        setCiudadImplicado(comunaActual && comunaActual.atr4)
        setIdCiudadImplicado(comunaActual && comunaActual.atr5);
      }
    }
  }, [datosPantalla, isImplicado, comboComunas]);
  
  const handleEsConductor = (e) => {
    formik.handleChange(e);
    if (e.target.checked) {
      setStateChkConductor(true)
    } else {;
      setStateChkConductor(false)
    }    
  };
  const handleEsPropietario = (e) =>{
    formik.handleChange(e);
    if (e.target.checked) {
      setStateChkPropietario(true);
    } else {
      setStateChkPropietario(false);
    }   
  };
  useEffect(() => {
  
    if (isImplicado && (tipoInvolucradoTmp == 205001)) {//Corresponde a un ingreso de implicado
      setMuestraChk(true);
    } else {
      setMuestraChk(false);
    }
    if (!isImplicado) {//Corresponde a una edición de implicado
      if (!isValidParam(tipoInvolucradoTmp) && tipoInvolucradoBD == 205001) {
        setMuestraChk(true);
      }
      if (isValidParam(tipoInvolucradoTmp) && tipoInvolucradoTmp == 205001) {
        setMuestraChk(true);
      }
    }
  }, [tipoInvolucradoTmp, tipoInvolucradoBD]);

  return (
    <>
      {/* <Container> */}
      <Card className='mt-2'>
        <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}>
          {cfg_form37 ? cfg_form37.cfg_form37['casograldefensa-editimpl-title-implicado']: null}          
        </Card.Header>
        <Container>
          {cfg_form37 ? (
            <div>
              {muestraChk ? (
              <Row>
                <Col md="3">
                  <Form.Check className='mt-2' checked={stateChkConductor} name="esConductor" value="1" type='checkbox' label='Es Conductor' onChange={(e)=>{handleEsConductor(e)}} />
                </Col>
                <Col md="2">
                  <Form.Check className='mt-2' checked={stateChkPropietario} name="esPropietario" value="1" type='checkbox' label='Es Propietario' onChange={(e)=>{handleEsPropietario(e)}} />
                </Col>
              </Row>
              ) : ('')
              }
              <Row></Row><Row></Row>
              <Row>
                <Col>
                  <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form37.cfg_form37['casograldefensa-editimpl-rutimpl']}
                  </Form.Label>{' '}
                  <br />
                  {isImplicado ?
                    <Form.Text className='mb-3'>
                      {formik.values.rutImplicadoTercero && formik.values.rutImplicadoTercero !== 'undefined'
                        ? formato_rut(formik.values.rutImplicadoTercero) : ''}
                    </Form.Text> :
                    <>
                      <Form.Control
                        className='mt-2 w-75'
                        autoComplete='off'
                        onChange={(e) => {
                          formik.handleChange(e)
                          setRutImplicado(e.target.value)
                          setRutImplicadoNoFormato(e.target.value)
                        }}
                        value={
                          (formik.values.rutImplicado =
                            rutImplicado !== undefined && rutImplicado)
                        }
                        onFocus={() =>
                          rutImplicado !== ''
                            ? setRutImplicado(rutImplicadoNoFormato)
                            : ''
                        }
                        onBlur={() => {
                          setRutImplicado(formato_rut(rutImplicado))
                        }}
                        name='rutImplicado'
                        error={formik.errors.rutImplicado}
                      ></Form.Control>
                      {formik.errors.rutImplicado ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.rutImplicado}
                        </Form.Text>
                      ) : (
                        ''
                      )}
                    </>
                  }
                </Col>
                <Col>
                  <Form.Label className=' mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form37.cfg_form37['casograldefensa-editimpl-nomimpl']}
                  </Form.Label>
                  <br />
                  {isImplicado ?
                    <Form.Text className='mb-3'>
                      {formik.values.nombreInvolucradoTercero && formik.values.nombreInvolucradoTercero !== 'undefined'
                        ? formik.values.nombreInvolucradoTercero : ''}
                    </Form.Text> :
                    <>
                      <Form.Control
                        className='mt-2 w-75'
                        value={
                          (formik.values.nombreImplicado =
                            nombreImplicado !== undefined && nombreImplicado)
                        }
                        onChange={(e) => {
                          formik.handleChange(e)
                          setNombreImplicado(e.target.value)
                        }}
                        name='nombreImplicado'
                        error={formik.errors.nombreImplicado}
                      ></Form.Control>
                      {formik.errors.nombreImplicado ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.nombreImplicado}
                        </Form.Text>
                      ) : (
                        ''
                      )}
                    </>
                  }
                </Col>
                <Col>
                  <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form37.cfg_form37['casograldefensa-editimpl-dirimpl']}
                  </Form.Label>
                  <br />
                  <Form.Control
                    className='mt-2'
                    value={
                      (formik.values.direccionImplicado =
                        direccionImplicado !== undefined && direccionImplicado)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setDireccionImplicado(e.target.value)
                    }}
                    name='direccionImplicado'
                    error={formik.errors.direccion}
                  ></Form.Control>
                  {formik.errors.direccionImplicado ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.direccionImplicado}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>

                <Col>
                  <Form.Label className='mb-0'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form37.cfg_form37['casograldefensa-editimpl-emailimpl']}
                  </Form.Label>
                  <br />
                  <Form.Control
                    className='mt-2'
                    value={
                      (formik.values.emailImplicado =
                        emailImplicado !== undefined && emailImplicado)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setEmailImplicado(e.target.value)
                    }}
                    name='emailImplicado'
                    error={formik.errors.emailImplicado}
                  ></Form.Control>
                  {formik.errors.emailImplicado ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.emailImplicado}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form37.cfg_form37['casograldefensa-editimpl-fonoimpl']}
                  </Form.Label>
                  <br />
                  <InputGroup className='mb-3 w-75'>
                    <Form.Select
                      className='mt-2 w-25'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)
                        setPaisImplicado(e.target.value)
                      }}
                      name='paisImplicado'
                      value={(formik.values.paisImplicado = paisImplicado)}
                      error={formik.errors.paisImplicado}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboPais &&
                        comboPais.comboPais?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.pais ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.pais}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                    <Form.Control className='mt-2 w-50'
                      value={
                        (formik.values.fonoImplicado =
                          fonoImplicado !== undefined && fonoImplicado)
                      }
                      onKeyDown={(e) => {
                        validaNumeros(e)
                      }}
                      onChange={(e) => {
                        formik.handleChange(e)
                        setFonoImplicado(e.target.value)
                      }}
                      name='fonoImplicado'
                      error={formik.errors.fonoImplicado}
                    ></Form.Control>
                    {formik.errors.fonoImplicado ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.fonoImplicado}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </InputGroup>
                </Col>
                <Col>
                  <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form37.cfg_form37['casograldefensa-editimpl-movilimpl']}
                  </Form.Label>
                  <br />
                  <InputGroup className='mb-3 w-75'>
                    <Form.Select
                      className='mt-2 w-25'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)
                        setPaisMovilImplicado(e.target.value)
                      }}
                      name='paisMovilImplicado'
                      value={(formik.values.paisMovilImplicado = paisMovilImplicado)}
                      error={formik.errors.paisMovilImplicado}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboPais &&
                        comboPais.comboPais?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.paisMovilImplicado ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.paisMovilImplicado}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                    <Form.Control
                      className='mt-2 w-50'
                      value={
                        (formik.values.movilImplicado =
                          movilImplicado !== undefined && movilImplicado)
                      }
                      onChange={(e) => {
                        formik.handleChange(e)
                        setMovilImplicado(e.target.value)
                      }}
                      name='movilImplicado'
                      error={formik.errors.movilImplicado}
                    ></Form.Control>
                    {formik.errors.movilImplicado ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.movilImplicado}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </InputGroup>
                </Col>

                <Col>
                  <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form37.cfg_form37['casograldefensaeditimpl-comunaimpl']}
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2 w-75'
                    aria-label='Default select example'
                    onChange={(e) => {
                      formik.handleChange(e)
                      const comunaActual =
                        comboComunas &&
                        comboComunas.comboComunas?.find(
                          (c) => c.id === e.target.value
                        )
                      setCiudadImplicado(comunaActual.atr4)
                      setComunaImplicado(e.target.value)
                      setIdCiudadImplicado(comunaActual && comunaActual.atr5);
                    }}
                    name='comunaImplicado'
                    value={(formik.values.comunaImplicado = comunaImplicado)}
                    error={formik.errors.comunaImplicado}
                  >
                    <option value={''}>Seleccione...</option>
                    {comboComunas &&
                      comboComunas.comboComunas?.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                        </option>
                      ))}
                  </Form.Select>
                  {formik.errors.comunaImplicado ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.comunaImplicado}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
                <Col>
                  <Form.Label className='mt-3 mb-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form37.cfg_form37['casograldefensa-editimpl-ciudadimpl']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                    {ciudadImplicado}
                  </Form.Text>
                </Col>
              </Row>
            </div>
          ) : null}
        </Container>
      </Card>
    </>
  )
}

export default Implicado
